import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AnimationHelper } from 'src/app/helpers/animation.helper';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ShellService } from 'src/app/services/process/shell.service';
import { IconsService } from 'src/app/services/ux/icons.service';
import { ThemeService } from 'src/app/services/ux/theme.service';

@Component({
  selector: 'app-start-menu',
  templateUrl: './start-menu.component.html',
  styleUrls: ['./start-menu.component.scss']
})
export class StartMenuComponent implements OnInit {
  private lastPicture = "";
  private pictureUrl: any = "";

  constructor(
    private sanitizer: DomSanitizer,
    public theme: ThemeService,
    private shell: ShellService,
    private authSv: AuthService,
    private iconSv: IconsService) {
  }

  ngOnInit(): void {
    AnimationHelper.animate(this.container, "fadeInUp");
  }

  private get container() {
    const element = document.getElementById("start-menu");
    return element;
  }

  get isLogged() {
    return this.authSv.isLogged;
  }

  get userName() {
    return this.isLogged ? this.authSv.user.name : "Guest";
  }

  get picture() {
    const target = (this.isLogged ? this.authSv.user.pictureUrl : this.iconSv.getIcon("user")) || this.iconSv.getIcon("user");

    if (this.lastPicture !== target) {
      this.lastPicture = target;
      if (this.isLogged) {
        this.pictureUrl = this.sanitizer.bypassSecurityTrustUrl(target);
      }
      else {
        this.pictureUrl = target;
      }
    }

    return this.pictureUrl;
  }

  userClick() {
    this.shell.launchApp("app://profile", "user");
  }
}
